// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_UFsrf","foot_link":"index_foot_link_uRIne","list":"index_list_k-U4F","link":"index_link_ykBD-","copyright":"index_copyright_g1nzK"};